/*!
 * CORE.Monocle.js
 * ----------------------------------------------
 * Package:  @ttcorestudio/monocle
 * Version:  0.3.57
 * Compiled: 2021-09-24T17:46:22.922Z
 * ----------------------------------------------
 */
(function (global, factory) {
 typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
 typeof define === 'function' && define.amd ? define(factory) :
 (global.CORE = global.CORE || {}, global.CORE.Monocle = factory());
}(this, (function () { 'use strict';
 var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
   return typeof obj;
 } : function (obj) {
   return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
 };
 var classCallCheck = function (instance, Constructor) {
   if (!(instance instanceof Constructor)) {
     throw new TypeError("Cannot call a class as a function");
   }
 };
 var slicedToArray = function () {
   function sliceIterator(arr, i) {
     var _arr = [];
     var _n = true;
     var _d = false;
     var _e = undefined;
     try {
       for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
         _arr.push(_s.value);
         if (i && _arr.length === i) break;
       }
     } catch (err) {
       _d = true;
       _e = err;
     } finally {
       try {
         if (!_n && _i["return"]) _i["return"]();
       } finally {
         if (_d) throw _e;
       }
     }
     return _arr;
   }
   return function (arr, i) {
     if (Array.isArray(arr)) {
       return arr;
     } else if (Symbol.iterator in Object(arr)) {
       return sliceIterator(arr, i);
     } else {
       throw new TypeError("Invalid attempt to destructure non-iterable instance");
     }
   };
 }();
 var MonocleViewer = function MonocleViewer(monocle) {
     classCallCheck(this, MonocleViewer);
     this.canvas = null;
     this.scale = 1;
     this.scaleTracker = null;
     this.selectionColor = "#FFCB00";
     this.selectionWeight = 3;
     this.hoverSensitivity = 6;
     this.colorByWeight = 3;
     this.colorByFill = false;
     this.colorByOpacity = 1.0;
     this.isLabeled = false;
     this.labelHeight = 8;
 };
 function sampleFunction2() {}
 function addCanvas(divTag) {
     var heightCoeff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.75;
     var widthCoeff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.85;
     var viewerDiv = document.getElementById(divTag);
     var canvas = d3.select(viewerDiv).append("svg"),
         width = +canvas.attr("width"),
         height = +canvas.attr("height");
     canvas.attr("id", "canvas");
     function redraw() {
         var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
         var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
         width = w * widthCoeff;
         height = h * heightCoeff;
         canvas.attr("width", width).attr("height", height);
     }
     redraw();
     window.addEventListener("resize", redraw);
     this.viewer.canvas = canvas;
     this.viewer.canvas.append("rect").attr("width", width).attr("height", height).attr("id", "boundary").style("fill", "none").style("pointer-events", "all");
     this.viewer.group = this.viewer.canvas.append("g").attr('id', 'viewer').attr('width', width).attr('height', height);
     var monocle = this;
     this.viewer.zooms = this.viewer.canvas.call(d3.zoom().on("zoom", function () {
         monocle.zoomed(monocle);
     }));
     this.viewer.zoomFunction = d3.zoom().on("zoom", function () {
         monocle.zoomed(monocle);
     });
     this.defs = this.viewer.canvas.append('defs');
     this.styles = this.defs.append('style');
 }
 function load(collection) {
     this.dataCollection = collection;
 }
 function setHoverColor(color) {
     var monocle = this;
     monocle.viewer.selectionColor = color;
 }
 function setHoverSensitivity(weight) {
     var monocle = this;
     monocle.viewer.hoverSensitivity = weight;
 }
 function setHoverWeight(weight) {
     var monocle = this;
     monocle.viewer.selectionWeight = weight;
 }
 function setColorByWeight(weight) {
     var monocle = this;
     monocle.viewer.colorByWeight = weight;
 }
 function setColorByOpacity(opacity) {
     var monocle = this;
     monocle.viewer.colorByOpacity = opacity;
 }
 function setColorByFill(status) {
     var monocle = this;
     monocle.viewer.colorByFill = status;
 }
 function resolveDrawing(urls) {
     addGroup(urls, urls.monocleId);
 }
 function addStyleOverride(paths, style, className) {
     var styleString = "";
     Object.keys(style).forEach(function (s) {
         return styleString += s + ": " + style[s].toString() + "; ";
     });
     paths.forEach(function (p) {
         p.setAttribute("style", styleString);
         p.setAttribute("vector-effect", "none");
         p.classList.add(className);
     });
 }
 function removeAllColorBy() {
     this.removeColorByAttribute(Object.values(this.dataCollection.groups), "colorBy");
 }
 function grayoutAll(clear, revert) {
     var _this = this;
     Object.values(this.dataCollection.groups).forEach(function (group) {
         var gp = _this.viewer.canvas.select("#x" + group.monocleId);
         var paths = gp.selectAll('path');
         if (revert == true) {
             gp._groups.forEach(function (g) {
                 g.forEach(function (e) {
                     e.setAttribute("style", "opacity:1;");
                 });
             });
             paths._groups.forEach(function (p) {
                 p.forEach(function (a) {
                     if (a.classList.contains("grayOutStyle")) a.classList.remove("grayOutStyle");
                     a.removeAttribute("style");
                 });
             });
         } else {
             if (clear === true) {
                 gp._groups.forEach(function (g) {
                     g.forEach(function (e) {
                         e.setAttribute("style", "opacity:0.0;");
                     });
                 });
             }
             paths._groups.forEach(function (p) {
                 p.forEach(function (a) {
                     a.removeAttribute("style");
                     if (clear !== true) {
                         a.classList.add("grayOutStyle");
                     }
                 });
             });
         }
     });
     Object.values(this.dataCollection.groups).forEach(function (group) {
         var gp = _this.viewer.canvas.select("#" + group.monocleId);
         var paths = gp.selectAll('path');
         paths._groups.forEach(function (p) {
             p.forEach(function (a) {
                 if (a.classList.contains("colorBy")) a.classList.remove("colorBy");
                 if (a.classList.contains("highLight")) a.classList.remove("highLight");
                 a.removeAttribute("style");
                 a.setAttribute("vector-effect", "non-scaling-stroke");
             });
         });
     });
 }
 function removeColorByAttribute(groups, className) {
     var _this2 = this;
     this.threadData.colorbyGroups = null;
     this.threadData.colorbyData = null;
     groups.forEach(function (group) {
         var gp = _this2.viewer.canvas.select("#" + group.monocleId);
         var paths = gp.selectAll('path');
         paths._groups.forEach(function (p) {
             p.forEach(function (a) {
                 if (a.classList.contains(className)) a.classList.remove(className);
                 a.removeAttribute("style");
                 a.setAttribute("vector-effect", "non-scaling-stroke");
             });
         });
     });
 }
 function setLayerVisibilityStatus(layer) {
     var _this3 = this;
     var monocle = this;
     Object.keys(monocle.dataCollection.groups).forEach(function (key) {
         var group = monocle.dataCollection.groups[key];
         var layers = group.layers;
         if (layers.includes(layer.monocleId)) {
             var gp = _this3.viewer.canvas.select("#" + group.monocleId);
             gp._groups.forEach(function (g) {
                 g.forEach(function (e) {
                     if (layer.opacity < 1.0) {
                         e.setAttribute("style", "opacity:0.0;");
                     } else {
                         e.setAttribute("style", "opacity:1.0;");
                     }
                 });
             });
             gp = _this3.viewer.canvas.select("#x" + group.monocleId);
             gp._groups.forEach(function (g) {
                 g.forEach(function (e) {
                     if (layer.opacity < 1.0) {
                         e.setAttribute("style", "opacity:0.0;");
                     } else {
                         e.removeAttribute("style");
                     }
                 });
             });
         }
     });
 }
 function setLayerLockStatus(layer) {
     var _this4 = this;
     var monocle = this;
     Object.keys(monocle.dataCollection.groups).forEach(function (key) {
         var group = monocle.dataCollection.groups[key];
         var layers = group.layers;
         if (layers.includes(layer.monocleId)) {
             var gp = _this4.viewer.canvas.select("#" + group.monocleId);
             gp._groups.forEach(function (g) {
                 g.forEach(function (e) {
                     if (layer.isLocked == true) {
                         e.setAttribute("style", "pointer-events: none;");
                     } else {
                         e.setAttribute("style", "pointer-events: all;");
                     }
                 });
             });
         }
     });
 }
 function filterElement(groups, data, grayOut, revert) {
     var _this5 = this;
     var monocle = this;
     if (revert == true) this.threadData.filteredGroups = null;else this.threadData.filteredGroups = groups;
     this.grayoutAll(grayOut, revert);
     if (!groups || groups.length === 0 || revert == true) return;
     groups.forEach(function (group, index) {
         var gp = _this5.viewer.canvas.select("#" + group.monocleId);
         if (group.monocleId in _this5.dataCollection.dataObjects) {
             var color = "#000000";
             if (data != null) color = data[index].color;
             var paths = gp.selectAll('path');
             paths._groups.forEach(function (p) {
                 if (p && color) {
                     if (monocle.viewer.colorByFill == true) {
                         addStyleOverride(p, { "stroke": color, "fill": color, "fill-opacity": monocle.viewer.colorByOpacity, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity }, "filter");
                     } else {
                         addStyleOverride(p, { "stroke": color, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity, "fill-opacity": 0 }, "filter");
                     }
                 }
             });
         }
     });
 }
 function colorElement(groupIds, colors, grayOut, reset) {
     var _this6 = this;
     var monocle = this;
     if (grayOut === true) this.grayoutAll(grayOut, false);
     if (reset !== false) this.resetLayer();
     if (!groupIds || !colors || groupIds.length === 0 || groupIds.length !== colors.length) return;
     groupIds.forEach(function (gId, index) {
         var gp = _this6.viewer.canvas.select("#" + gId);
         if (gId in _this6.dataCollection.dataObjects) {
             var color = colors[index];
             var paths = gp.selectAll('path');
             paths._groups.forEach(function (p) {
                 if (p && color) {
                     if (monocle.viewer.colorByFill == true) {
                         addStyleOverride(p, { "stroke": color, "fill": color, "fill-opacity": monocle.viewer.colorByOpacity, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity }, "highLight");
                     } else {
                         addStyleOverride(p, { "stroke": color, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity, "fill-opacity": 0 }, "highLight");
                     }
                 }
             });
         }
     });
 }
 function resetXLayer() {
     var _this7 = this;
     Object.values(this.dataCollection.groups).forEach(function (group) {
         var gp = _this7.viewer.canvas.select("#x" + group.monocleId);
         var paths = gp.selectAll('path');
         gp._groups.forEach(function (g) {
             g.forEach(function (e) {
                 e.setAttribute("style", "opacity:1;");
             });
         });
         paths._groups.forEach(function (p) {
             p.forEach(function (a) {
                 if (a.classList.contains("grayOutStyle")) a.classList.remove("grayOutStyle");
                 if (a.classList.contains("selectionStyle")) a.classList.remove("selectionStyle");
                 if (a.classList.contains("hoverStyle")) a.classList.remove("hoverStyle");
                 a.removeAttribute("style");
             });
         });
     });
 }
 function resetLayer() {
     var _this8 = this;
     Object.values(this.dataCollection.groups).forEach(function (group) {
         var gp = _this8.viewer.canvas.select("#" + group.monocleId);
         var paths = gp.selectAll('path');
         gp._groups.forEach(function (g) {
             g.forEach(function (e) {
                 e.setAttribute("style", "opacity:1;");
             });
         });
         paths._groups.forEach(function (p) {
             p.forEach(function (a) {
                 if (a.classList.contains("grayOutStyle")) a.classList.remove("grayOutStyle");
                 if (a.classList.contains("selectionStyle")) a.classList.remove("selectionStyle");
                 if (a.classList.contains("hoverStyle")) a.classList.remove("hoverStyle");
                 a.removeAttribute("style");
             });
         });
     });
 }
 function clearExistingHighlightOutlines() {
     var _this9 = this;
     Object.values(this.dataCollection.groups).forEach(function (group) {
         var gp = _this9.viewer.canvas.select("#x" + group.monocleId);
         var paths = gp.selectAll('path');
         paths._parents.forEach(function (p) {
             p.style["outline-style"] = "";
             p.style["outline-width"] = "";
             p.style["outline-color"] = "";
         });
     });
 }
 function highlightElementByIds(groupIds, colors) {
     var _this10 = this;
     var monocle = this;
     this.resetXLayer();
     if (!groupIds || groupIds.length === 0) return;
     groupIds.forEach(function (gId, i) {
         var gp = _this10.viewer.canvas.select("#x" + gId);
         if (gId in _this10.dataCollection.dataObjects) {
             var color = colors[i];
             var paths = gp.selectAll('path');
             paths._parents.forEach(function (p) {
                 if (p && color) {
                     p.style["outline-style"] = "solid";
                     p.style["outline-width"] = monocle.viewer.colorByWeight;
                     p.style["outline-color"] = color;
                 }
             });
         }
     });
 }
 function highLightElement(groups, attr, data, grayOut, revert) {
     var _this11 = this;
     var monocle = this;
     var filteredGroupIds = null;
     if (this.threadData.filteredGroups) filteredGroupIds = this.threadData.filteredGroups.map(function (gr) {
         return gr.monocleId;
     });
     if (revert == true && this.threadData.filteredGroups != null) {
         var newColorData;
         if (this.threadData.colorbyGroups && this.threadData.colorbyData) {
             var allGroupIds = this.threadData.colorbyGroups.map(function (g) {
                 return g.monocleId;
             });
             newColorData = this.threadData.filteredGroups.map(function (fg) {
                 var index = allGroupIds.indexOf(fg.monocleId);
                 if (index < 0) return null;
                 return _this11.threadData.colorbyData[index];
             });
         } else newColorData = null;
         this.filterElement(this.threadData.filteredGroups, newColorData, grayOut, false);
         return;
     }
     this.grayoutAll(grayOut, revert);
     if (!groups || !data || groups.length === 0 || groups.length !== data.length) return;
     groups.forEach(function (group, index) {
         var gp = _this11.viewer.canvas.select("#" + group.monocleId);
         if (group.monocleId in _this11.dataCollection.dataObjects) {
             var color = data[index].color;
             var paths = gp.selectAll('path');
             paths._groups.forEach(function (p) {
                 if (p && color) {
                     if (monocle.viewer.colorByFill == true) {
                         addStyleOverride(p, { "stroke": color, "fill": color, "fill-opacity": monocle.viewer.colorByOpacity, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity }, "highLight");
                     } else {
                         addStyleOverride(p, { "stroke": color, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity, "fill-opacity": 0 }, "highLight");
                     }
                 }
             });
         }
     });
 }
 function colorByAttribute(groups, attr, gradientColors) {
     var _this12 = this;
     var monocle = this;
     this.threadData.colorbyGroups = null;
     this.threadData.colorbyData = null;
     var colorbyGroups = [];
     var colorbyVals = [];
     var filteredGroupIds = null;
     if (this.threadData.filteredGroups) filteredGroupIds = this.threadData.filteredGroups.map(function (gr) {
         return gr.monocleId;
     });
     this.removeAllColorBy();
     var attrValues = [];
     var groupToAttrDict = {};
     Object.values(this.dataCollection.dataObjects).forEach(function (d) {
         if (attr in d.attributes) {
             var val = d.attributes[attr].value;
             if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === 'object' && val !== null) val = val.Value;
             groupToAttrDict[d.monocleId] = val;
             if (val) {
                 if (val != "") {
                     if (!attrValues.includes(val)) {
                         attrValues.push(val);
                     }
                 }
             }
         }
     });
     var gradDict = advancedGradientDict(gradientColors, attrValues);
     groups.forEach(function (group) {
         colorbyGroups.push(group);
         var gp = _this12.viewer.canvas.select("#" + group.monocleId);
         if (group.monocleId in _this12.dataCollection.dataObjects) {
             if (attr in _this12.dataCollection.dataObjects[group.monocleId].attributes) {
                 var value = groupToAttrDict[group.monocleId];
                 var color = gradDict[value];
                 colorbyVals.push({ "value": value, "color": color });
                 if (filteredGroupIds != null) {
                     if (filteredGroupIds.indexOf(group.monocleId) < 0) return;
                 }
                 var paths = gp.selectAll('path');
                 paths._groups.forEach(function (p) {
                     if (p && color) {
                         if (monocle.viewer.colorByFill == true) {
                             addStyleOverride(p, { "stroke": color, "fill": color, "fill-opacity": monocle.viewer.colorByOpacity, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity }, "colorBy");
                         } else {
                             addStyleOverride(p, { "stroke": color, "stroke-width": monocle.viewer.colorByWeight, 'stroke-opacity': monocle.viewer.colorByOpacity }, "colorBy");
                         }
                     }
                 });
             }
         }
     });
     this.threadData.colorbyGroups = colorbyGroups;
     this.threadData.colorbyData = colorbyVals;
     return gradDict;
 }
 function advancedGradientDict(colors, values) {
     var d = {};
     var isNumeric = !values.some(isNaN);
     if (isNumeric == true) {
         values.sort(function (a, b) {
             return b - a;
         });
         values.reverse();
     } else {
         values.sort();
     }
     var ranger = null;
     var allNums = values.every(function (element) {
         return typeof element === 'number';
     });
     if (!allNums) {
         ranger = getColorScale(colors, [0, values.length - 1]);
         for (var i = 0; i < values.length; i++) {
             d[values[i]] = ranger(i);
         }
     } else {
         ranger = getColorScale(colors, [0, Math.max.apply(Math, values)]);
         values.forEach(function (v) {
             d[v] = ranger(v);
         });
     }
     return d;
 }
 function getColorScale(colors, range) {
     var numRanger = d3.scaleLinear().domain([0, colors.length - 1]).range(range);
     var nums = colors.map(function (color, i) {
         return numRanger(i);
     });
     return d3.scaleLinear().domain(nums).range(colors);
 }
 function removeHoverColor(paths, className) {
     paths.forEach(function (p) {
         p.removeAttribute("style");
         if (p.classList.contains(className)) p.classList.remove(className);
     });
 }
 function loadData(drawings, urls, callback) {
     return new Promise(async function (resolve, reject) {
         var dataObjects = [];
         drawings.forEach(function (drawing) {
             if (drawing.monocleId in urls) {
                 urls[drawing.monocleId].forEach(function (url) {
                     dataObjects = dataObjects.concat(resolveDataUrl(url, callback));
                 });
             }
         });
         Promise.all(dataObjects).then(function (values) {
             var concatenated = [];
             values.forEach(function (v) {
                 return concatenated = concatenated.concat(v);
             });
             resolve(concatenated);
         });
     });
 }
 function renderDrawings(drawings, urls, callback) {
     var monocle = this;
     return new Promise(async function (resolve, reject) {
         var minObjects = [];
         drawings.forEach(function (drawing) {
             if (drawing.monocleId in urls) {
                 urls[drawing.monocleId].forEach(function (url) {
                     var resolved = resolveUrl(url, drawing, monocle, callback);
                     minObjects = minObjects.concat(resolved);
                 });
             }
         });
         Promise.all(minObjects).then(function (values) {
             var concatenated = [];
             values.forEach(function (v) {
                 return concatenated = concatenated.concat(v);
             });
             resolve(concatenated);
         });
     });
 }
 function clearDrawings() {
     this.viewer.canvas.select("g").selectAll(function () {
         return this.childNodes;
     }).remove();
 }
 function resolveUrl(url, drawing, monocle, callback) {
     return new Promise(function (resolve, reject) {
         $.get(url).then(function (obj) {
             if (obj) {
                 var minimalObjects = [];
                 Object.values(obj.groups).forEach(function (minObj) {
                     if (minObj.monocleId in drawing.monocleObjects) {
                         var minimalObject = drawing.monocleObjects[minObj.monocleId];
                         minimalObject.monocleId = minObj.monocleId;
                         minimalObject.data = minObj;
                         minimalObject.drawingId = drawing.monocleId;
                         monocle.renderToSheet(minimalObject);
                         minimalObjects.push(minimalObject);
                     }
                 });
                 if (callback) callback();
                 resolve(minimalObjects);
             } else {
                 reject();
             }
         });
     });
 }
 function resolveDataUrl(url, callback) {
     return new Promise(function (resolve, reject) {
         try {
             $.get(url).then(function (obj) {
                 if (obj) {
                     var dataObjects = [];
                     Object.values(obj.data).forEach(function (dpt) {
                         dataObjects.push(dpt);
                     });
                     if (callback) callback();
                     resolve(dataObjects);
                 } else {
                     reject();
                 }
             });
         } catch (ex) {}
     });
 }
 function setAllLayers() {
     var _this13 = this;
     var monocle = this;
     var layers = monocle.dataCollection.layerObjects;
     layers.forEach(function (layer) {
         _this13.setLayerLockStatus(layer);
     });
 }
 function setSheet(sheetIndex) {
     var monocle = this;
     var project = monocle.dataCollection;
     var canvas = monocle.viewer.canvas;
     var drawings = [];
     return new Promise(function (resolve, reject) {
         var sheets = project.sheetObjects;
         var sheet = sheets[sheetIndex];
         var viewports = sheet.viewports;
         viewports.forEach(function (viewport) {
             drawings.push(viewport.drawing);
             addViewport(viewport);
         });
         var graphics = project.graphicObjects;
         var fonts = project.fontObjects;
         monocle.dataCollection.fontCollection = {};
         addStyles(graphics);
         addFonts(fonts);
         if (drawings) {
             resolve(drawings);
         } else {
             reject(Error("Sheets Failed"));
         }
     });
     function addViewport(viewport) {
         var drawing = viewport.drawing;
         monocle.viewer.group.append("svg:g").attr("id", drawing.monocleId).append("svg:path");
         var obj = canvas.select("#" + drawing.monocleId);
         return obj;
     }
     function addStyles(graphicObjs) {
         var array = graphicObjs;
         var hoverStyle = {};
         hoverStyle.monocleId = "hoverstyle";
         hoverStyle.fillColor = "#FFCB00";
         hoverStyle.fillOpacity = 0.8;
         hoverStyle.strokeColor = "#FF0000";
         hoverStyle.strokeOpacity = 0.8;
         hoverStyle.strokeWeight = 3.0;
         array.push(hoverStyle);
         var selectionStyle = {};
         selectionStyle.monocleId = "selectionstyle";
         selectionStyle.fillColor = "#FFCB00";
         selectionStyle.fillOpacity = 0.0;
         selectionStyle.strokeColor = "#FFCB00 ";
         selectionStyle.strokeOpacity = 0.0;
         selectionStyle.strokeWeight = monocle.viewer.hoverSensitivity;
         array.push(selectionStyle);
         var grayOutStyle = {};
         grayOutStyle.monocleId = "grayOutStyle";
         grayOutStyle.fillColor = "#b5b5b5";
         grayOutStyle.fillOpacity = 0.0;
         grayOutStyle.strokeColor = "#b5b5b5";
         grayOutStyle.strokeOpacity = 1.0;
         grayOutStyle.strokeWeight = 1;
         array.push(grayOutStyle);
         var lockedStyle = {};
         lockedStyle.monocleId = "lockedStyle";
         lockedStyle.fillColor = "#FFFFFF";
         lockedStyle.fillOpacity = 0.0;
         lockedStyle.strokeColor = "#d3d3d3 ";
         lockedStyle.strokeOpacity = 1.0;
         lockedStyle.strokeWeight = monocle.viewer.hoverSensitivity;
         array.push(lockedStyle);
         for (var i = 0; i < array.length; i++) {
             var styleTable = "";
             styleTable += setStyle(array[i]);
             styleTable += "\n";
             var style = monocle.defs.append('style');
             style.text(styleTable);
         }
     }
     function setStyle(graphic) {
         var cssStyle = {
             "fill": graphic.fillColor,
             "fill-opacity": graphic.fillOpacity,
             "stroke": graphic.strokeColor,
             "stroke-width": graphic.strokeWeight,
             "stroke-opacity": graphic.strokeOpacity,
             "stroke-linecap": "round",
             "stroke-miterlimit": 10
         };
         if (graphic.strokePattern) {
             if (graphic.strokePattern.length > 0) {
                 if (graphic.strokePattern.length === 1 & graphic.strokePattern.length > 1) {
                     var pattern = graphic.strokePattern.map(function (v) {
                         return Math.floor(Math.abs(v / 2.834653) * 100) / 100;
                     });
                     cssStyle["stroke-dasharray"] = pattern;
                 }
             }
         }
         var styleText = '.' + graphic.monocleId + '{';
         Object.keys(cssStyle).forEach(function (k) {
             styleText += k + ":" + cssStyle[k] + ";";
         });
         styleText += '}';
         return styleText;
     }
     function addFonts(fontObjs) {
         var array = fontObjs;
         for (var i = 0; i < array.length; i++) {
             var styleTable = "";
             styleTable += setFont(array[i]);
             styleTable += "\n";
             var style = monocle.defs.append('style');
             style.text(styleTable);
             monocle.dataCollection.fontCollection[array[i].monocleId] = array[i];
         }
     }
     function setFont(font) {
         var vAlignments = Object.freeze({ 0: "hanging", 1: "middle", 2: "alphabetic" });
         var vAlign = vAlignments[font.verticalAlignment];
         var hAlignments = Object.freeze({ 0: "start", 1: "middle", 2: "end" });
         var hAlign = hAlignments[font.horizontalAlignment];
         var cssStyle = {
             "font-family": font.family,
             "font-size": Number.parseFloat(font.size / 2.83465).toPrecision(4) + "mm",
             "fill": font.color,
             "fill-opacity": 1,
             "alignment-baseline": vAlign,
             "text-anchor": hAlign
         };
         var styleText = '.' + font.monocleId + '{';
         Object.keys(cssStyle).forEach(function (k) {
             styleText += k + ":" + cssStyle[k] + ";";
         });
         styleText += '}';
         return styleText;
     }
 }
 function renderToSheet(group) {
     var monocle = this;
     var project = monocle.dataCollection;
     var canvas = monocle.viewer.canvas;
     return new Promise(function (resolve, reject) {
         var drawingObj = getDrawing(group.drawingId);
         var groupObj = addGroup(drawingObj, group);
         var hoverObj = addHighlightGroup(drawingObj, group);
         SetOnMouseHover(hoverObj, groupObj);
         if (groupObj) {
             resolve(groupObj);
         } else {
             reject(Error("Group Failed"));
         }
     });
     function SetOnMouseHover(groupA, groupB) {
         var paths = groupB.selectAll('path');
         groupA.on("mouseout", function () {
             paths._groups.forEach(function (objGroup) {
                 var isColorBy = true;
                 objGroup.forEach(function (path) {
                     if (path.classList.contains("colorBy") === true) isColorBy = false;
                 });
                 if (isColorBy) removeHoverColor(objGroup, "hover");
             });
         });
         groupA.on("mouseover", function () {
             paths._groups.forEach(function (objGroup) {
                 var isColorBy = true;
                 objGroup.forEach(function (path) {
                     if (path.classList.contains("colorBy") === true) isColorBy = false;
                 });
                 if (isColorBy) addStyleOverride(objGroup, { "stroke": monocle.viewer.selectionColor, "stroke-width": monocle.viewer.selectionWeight, "stroke-opacity": 1.0 }, "hover");
             });
         });
     }
     function getDrawing(drawingID) {
         var obj = canvas.select("#" + drawingID);
         return obj;
     }
     function addGroup(drawingObj, group) {
         drawingObj.append("svg:g").attr("id", "x" + group.monocleId).style("pointer-events", "all");
         var obj = drawingObj.select("#" + "x" + group.monocleId);
         var groupObj = group.data;
         var _iteratorNormalCompletion = true;
         var _didIteratorError = false;
         var _iteratorError = undefined;
         try {
             for (var _iterator = Object.entries(groupObj.figures)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                 var _step$value = slicedToArray(_step.value, 2),
                     key = _step$value[0],
                     value = _step$value[1];
                 addPaths(obj, value);
             }
         } catch (err) {
             _didIteratorError = true;
             _iteratorError = err;
         } finally {
             try {
                 if (!_iteratorNormalCompletion && _iterator.return) {
                     _iterator.return();
                 }
             } finally {
                 if (_didIteratorError) {
                     throw _iteratorError;
                 }
             }
         }
         var _iteratorNormalCompletion2 = true;
         var _didIteratorError2 = false;
         var _iteratorError2 = undefined;
         try {
             for (var _iterator2 = Object.entries(groupObj.textObjects)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                 var _step2$value = slicedToArray(_step2.value, 2),
                     key = _step2$value[0],
                     value = _step2$value[1];
                 addText(obj, value);
             }
         } catch (err) {
             _didIteratorError2 = true;
             _iteratorError2 = err;
         } finally {
             try {
                 if (!_iteratorNormalCompletion2 && _iterator2.return) {
                     _iterator2.return();
                 }
             } finally {
                 if (_didIteratorError2) {
                     throw _iteratorError2;
                 }
             }
         }
         return obj;
     }
     function addHighlightGroup(drawingObj, group) {
         var groupObj = drawingObj.append("svg:g").attr("id", group.monocleId);
         groupObj.style("pointer-events", "all");
         var obj = drawingObj.select("#" + group.monocleId);
         groupObj = group.data;
         var _iteratorNormalCompletion3 = true;
         var _didIteratorError3 = false;
         var _iteratorError3 = undefined;
         try {
             for (var _iterator3 = Object.entries(groupObj.figures)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                 var _step3$value = slicedToArray(_step3.value, 2),
                     key = _step3$value[0],
                     value = _step3$value[1];
                 addHighlightPaths(obj, value);
             }
         } catch (err) {
             _didIteratorError3 = true;
             _iteratorError3 = err;
         } finally {
             try {
                 if (!_iteratorNormalCompletion3 && _iterator3.return) {
                     _iterator3.return();
                 }
             } finally {
                 if (_didIteratorError3) {
                     throw _iteratorError3;
                 }
             }
         }
         return obj;
     }
     function addPaths(group, figure) {
         var _iteratorNormalCompletion4 = true;
         var _didIteratorError4 = false;
         var _iteratorError4 = undefined;
         try {
             for (var _iterator4 = Object.entries(figure.paths)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                 var _step4$value = slicedToArray(_step4.value, 2),
                     key = _step4$value[0],
                     value = _step4$value[1];
                 var geometry = getGeometry(value);
                 group.append("svg:path").attr("d", geometry).attr("class", figure.graphicId);
             }
         } catch (err) {
             _didIteratorError4 = true;
             _iteratorError4 = err;
         } finally {
             try {
                 if (!_iteratorNormalCompletion4 && _iterator4.return) {
                     _iterator4.return();
                 }
             } finally {
                 if (_didIteratorError4) {
                     throw _iteratorError4;
                 }
             }
         }
     }
     function addHighlightPaths(group, figure) {
         var _iteratorNormalCompletion5 = true;
         var _didIteratorError5 = false;
         var _iteratorError5 = undefined;
         try {
             for (var _iterator5 = Object.entries(figure.paths)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                 var _step5$value = slicedToArray(_step5.value, 2),
                     key = _step5$value[0],
                     value = _step5$value[1];
                 var geometry = getGeometry(value);
                 group.append("svg:path").attr("id", group.monocleId).attr("d", geometry).attr("class", "selectionstyle").attr("vector-effect", "non-scaling-stroke");
             }
         } catch (err) {
             _didIteratorError5 = true;
             _iteratorError5 = err;
         } finally {
             try {
                 if (!_iteratorNormalCompletion5 && _iterator5.return) {
                     _iterator5.return();
                 }
             } finally {
                 if (_didIteratorError5) {
                     throw _iteratorError5;
                 }
             }
         }
     }
     function addText(group, textObject) {
         var font = project.fontCollection[textObject.fontId];
         var fontSize = Number.parseFloat(font.size / 2.83465 * 4);
         var str = textObject.contents;
         var paragraph = str.split(/\r?\n/);
         if (paragraph.length < 2) {
             paragraph = str.split("\\P");
         }
         var rotation = textObject.rotation;
         if (rotation == undefined) rotation = textObject.Rotation;
         var Xp = Number.parseFloat(textObject.plane.Origin.X).toPrecision(4);
         var Yp = Number.parseFloat(textObject.plane.Origin.Y).toPrecision(4);
         var txtGrp = group.append("svg:g");
         var y = 0;
         paragraph.forEach(function (text) {
             txtGrp.append("text").text(text).attr("class", textObject.fontId).attr("transform", "rotate(-" + rotation + ") translate(0," + y + ")");
             y = y + fontSize;
         });
         txtGrp.attr("transform", "translate(" + Xp + "," + Yp + ")");
     }
     function getGeometry(path) {
         var rhGeometry = JSON.parse(path.data);
         var geometry = null;
         switch (path.type) {
             case "Rhino.Geometry.Line":
                 geometry = addLine(rhGeometry);
                 break;
             case "Rhino.Geometry.Arc":
                 geometry = addArc(rhGeometry);
                 break;
             case "Rhino.Geometry.Circle":
                 geometry = addCircle(rhGeometry);
                 break;
             case "Rhino.Geometry.Ellipse":
                 geometry = addEllipse(rhGeometry);
                 break;
             case "Rhino.Geometry.BezierCurve":
                 geometry = addSpline(rhGeometry);
                 break;
             case "Rhino.Geometry.Polyline":
                 geometry = addPolyline(rhGeometry);
                 break;
         }
         return geometry;
     }
     function addLine(rhLine) {
         return "M " + rhLine.FromX + " " + rhLine.FromY + " L " + rhLine.ToX + " " + rhLine.ToY;
     }
     function addArc(rhArc) {
         if (rhArc.IsCircle) {
             return "M " + (rhArc.Center.X - rhArc.Radius) + " " + rhArc.Center.Y + " a " + rhArc.Radius + ", " + rhArc.Radius + " 0 1,0 " + rhArc.Radius * 2 + ", 0" + " a " + rhArc.Radius + ", " + rhArc.Radius + " 0 1,0 " + rhArc.Radius * -2 + ", 0";
         } else {
             var rPtC = rhArc.MidPoint;
             var rPtA = rhArc.StartPoint;
             var rPtB = rhArc.EndPoint;
             var a = [rPtA.X, rPtA.Y];
             var b = [rPtB.X, rPtB.Y];
             var c = [rPtC.X, rPtC.Y];
             var A = dist(b, c);
             var B = dist(c, a);
             var C = dist(a, b);
             var angle = Math.acos((A * A + B * B - C * C) / (2 * A * B));
             var K = 0.5 * A * B * Math.sin(angle);
             var r = A * B * C / 4 / K;
             r = Math.round(r * 1000) / 1000;
             var laf = +(Math.PI / 2 > angle);
             var saf = +((b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]) < 0);
             return ['M', a, 'A', r, r, 0, laf, saf, b].join(' ');
         }
         function dist(a, b) {
             return Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2));
         }
     }
     function addCircle(rhCircle) {
         return "M " + (rhCircle.Center.X - rhCircle.Radius) + " " + rhCircle.Center.Y + " a " + rhCircle.Radius + ", " + rhCircle.Radius + " 0 1,0 " + rhCircle.Radius * 2 + ", 0" + " a " + rhCircle.Radius + ", " + rhCircle.Radius + " 0 1,0 " + rhCircle.Radius * -2 + ", 0";
     }
     function addEllipse(rhEllipse) {
         var Origin = rhEllipse.Plane.Origin;
         var Angle = getAngle(rhEllipse.Plane.XAxis);
         var x = Origin.X;
         var y = Origin.Y;
         var r1 = rhEllipse.Radius1;
         var r2 = rhEllipse.Radius2;
         var end = r1;
         if (Math.abs(rhEllipse.Plane.XAxis.Y) > Math.abs(rhEllipse.Plane.XAxis.X)) {
             end = r2;
         }
         return "M " + (Origin.X - end) + "," + Origin.Y + " a " + r1 + ", " + r2 + " " + 0 + " 1,0 " + 2 * end + ", " + 0 + " a " + r1 + ", " + r2 + " " + 0 + " 1,0 " + -2 * end + ", " + 0;
     }
     function addSpline(rhSpline) {
         var CVs = rhSpline.CVs;
         var count = CVs.length;
         var bezierPath = "M " + CVs[0] + " " + CVs[1] + " Q " + CVs[3] + " " + CVs[4] + " " + CVs[6] + " " + CVs[7] + " ";
         for (var i = 6; i < count - 6; i += 6) {
             bezierPath += "T " + CVs[i + 6] + " " + CVs[i + 7] + " ";
         }
         return bezierPath;
     }
     function addPolyline(rhPolyline) {
         var polyline = "M " + rhPolyline[0].X + " " + rhPolyline[0].Y + " ";
         for (var i = 1; i < rhPolyline.length; i++) {
             polyline = polyline + "L " + rhPolyline[i].X + " " + rhPolyline[i].Y + " ";
         }
         return polyline;
     }
     function getAngle(point) {
         var angle = Math.atan2(point.Y, point.X);
         var degrees = 180 * angle / Math.PI;
         return (360 + Math.round(degrees)) % 360;
     }
 }
 function findObjectsByValue(collection, property, value) {
     var objectsArray = [];
     collection.array.forEach(function (element) {
         if (element[property] == value) {
             objectsArray.push(element);
         }
     });
     return objectsArray;
 }
 function zoomed(obj) {
     obj.viewer.group.attr("transform", d3.event.transform);
     obj.updateScale(d3.event.transform.k);
 }
 function updateScale(s) {
     this.viewer.scale = s;
     if (this.viewer.scaleTracker != null) {
         this.viewer.scaleTracker.innerHTML = parseInt(s * 100) + "%";
     }
 }
 function scale(value) {
     this.viewer.zoomFunction.scaleBy(this.viewer.canvas, value);
 }
 function zoomRegion(id) {
     var objSource = $("#" + id)[0];
     var source = objSource.getBBox();
     var objTarget = document.getElementById("boundary");
     var target = objTarget.getBoundingClientRect();
     var s = 0.9 * Math.min(target.width / source.width, target.height / source.height);
     this.updateScale(s);
     var tx = target.width / 2 - s * (source.x * 2 + source.width) / 2;
     var ty = target.height / 2 - s * (source.y * 2 + source.height) / 2;
     this.viewer.canvas.transition().duration(750).call(this.viewer.zoomFunction.transform, d3.zoomIdentity.translate(tx, ty).scale(s));
 }
 function setScaleTracker(id) {
     this.viewer.scaleTracker = document.getElementById(id);
 }
 function SetAttributeOnMouseOver(groupID, attribute, value) {
     var containerGroup = this.viewer.group.select('#' + groupID);
     containerGroup.selectAll("g").on("mouseover", function () {
         var groupObj = d3.select(this).selectAll("path");
         groupObj.attr(attribute, value);
     });
 }
 function SetAttributeOnMouseOut(groupID, attribute, value) {
     var containerGroup = this.viewer.group.select('#' + groupID);
     containerGroup.selectAll("g").on("mouseout", function () {
         var groupObj = d3.select(this).selectAll("path");
         groupObj.attr(attribute, value);
     });
 }
 function SetOnClickHandler(groupID, handler) {
     var containerGroup = this.viewer.group.select('#' + groupID);
     var pathGroups = containerGroup.selectAll("path");
     pathGroups.on("click", handler);
 }
 function GetInstanceByRep(representationId) {
     var _this = this;
     if (!this.dataCollection || !this.dataCollection.instances) return;
     var instanceObjects = Object.keys(this.dataCollection.instances).filter(function (instanceId) {
         var instance = _this.dataCollection.instances[instanceId];
         var i;
         var drawingKeys = Object.keys(instance.re);
         for (i = 0; i < drawingKeys.length; i++) {
             if (instance.re[drawingKeys[i]].indexOf(representationId) >= 0) return instanceId;
         }
     });
     if (instanceObjects.length > 0) {
         return instanceObjects[0];
     }
 }
 function GetInstanceRepsByRep(representationId) {
     var instanceId = this.GetInstanceByRep(representationId);
     return this.GetAllInstanceReps(instanceId);
 }
 function GetAllInstanceReps(instanceId) {
     if (!this.dataCollection || !this.dataCollection.instances) return;
     if (Object.keys(this.dataCollection.instances).indexOf(instanceId) < 0) return;
     var repList = [];
     Object.values(this.dataCollection.instances[instanceId].re).forEach(function (arr) {
         repList = repList.concat(arr);
     });
     return repList;
 }
 function GetGroupData(groupId) {
     if (!this.dataCollection || !this.dataCollection.dataObjects) return;
     var dataSet = this.dataCollection.dataObjects;
     var match = dataSet[groupId];
     if (match) return match;else return {};
 }
 function GetInstanceData(instanceId) {
     if (!this.dataCollection || !this.dataCollection.instances || !this.dataCollection.data) return;
     if (Object.keys(this.dataCollection.instances).indexOf(instanceId) >= 0) {
         var monocle = this;
         var instance = this.dataCollection.instances[instanceId];
         var data = [];
         var i;
         for (i = 0; i < instance.da.length; i++) {
             var dataId = instance.da[i];
             if (Object.keys(monocle.dataCollection.data).indexOf(dataId) >= 0) {
                 var dataBlob = {};
                 dataBlob[dataId] = monocle.dataCollection.data[dataId];
                 data.push(dataBlob);
             }
         }
         return data;
     } else {
         return;
     }
 }
 function GetDataByKey(attributeName, value) {
     if (!this.dataCollection || !this.dataCollection.data) return;
     var i;
     var data = [];
     var dataIds = Object.keys(this.dataCollection.data);
     for (i = 0; i < dataIds.length; i++) {
         var dataId = dataIds[i];
         var dataPt = this.dataCollection.data[dataId];
         if (Object.keys(dataPt).indexOf(attributeName) >= 0) {
             if (dataPt[attributeName] == value) {
                 data.push(dataId);
             }
         }
     }
     return data;
 }
 function GetDataByAttribute(title, value) {
     if (!this.dataCollection || !this.dataCollection.data) return;
     var i;
     var data = [];
     var dataIds = Object.keys(this.dataCollection.data);
     for (i = 0; i < dataIds.length; i++) {
         var dataId = dataIds[i];
         var dataPt = this.dataCollection.data[dataId];
         if (dataPt.title == title) {
             if (dataPt.val == value) {
                 data.push(dataId);
             }
         }
     }
     return data;
 }
 function GetGradientMapByAttributeName(title) {
     var _this2 = this;
     var gradMin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
     var gradMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
     if (!this.dataCollection || !this.dataCollection.data) return;
     var i;
     var data = {};
     var valuesList = [];
     var dataIds = Object.keys(this.dataCollection.data);
     for (i = 0; i < dataIds.length; i++) {
         var dataId = dataIds[i];
         var dataPt = this.dataCollection.data[dataId];
         if (Object.keys(dataPt).indexOf("title") >= 0) {
             if (title == dataPt.title && !isNaN(dataPt.val)) {
                 var value = +dataPt.val;
                 data[dataId] = value;
                 valuesList.push(value);
             }
         }
     }
     var max = Math.max.apply(Math, valuesList);
     var min = Math.min.apply(Math, valuesList);
     Object.keys(data).forEach(function (id) {
         data[id] = _this2.ScaleNumber(data[id], min, max, gradMin, gradMax);
     });
     return data;
 }
 function ScaleNumber(value, oldMin, oldMax, newMin, newMax) {
     return (value - oldMin) / (oldMax - oldMin) * (newMax - newMin) + newMin;
 }
 function GetRepsByAttribute(title, value) {
     var drawingId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
     if (!this.dataCollection || !this.dataCollection.instances || !this.dataCollection.data) return;
     var dataPtIds = this.GetDataByAttribute(title, value);
     var instanceIds = [];
     var i;
     for (i = 0; i < dataPtIds.length; i++) {
         var dataId = dataPtIds[i];
         var instIds = this.GetInstancesByData(dataId);
         instanceIds = instanceIds.concat(instIds);
     }
     var reps = [];
     for (i = 0; i < instanceIds.length; i++) {
         var instanceId = instanceIds[i];
         var instance = this.dataCollection.instances[instanceId];
         if (drawingId == null) {
             reps = reps.concat(this.GetAllInstanceReps(instanceId));
         } else {
             if (Object.keys(instance.re).indexOf(drawingId) >= 0) {
                 reps = reps.concat(instance.re[drawingId]);
             }
         }
     }
     return reps;
 }
 function GetRepsOnSheetByAttribute(title, value, sheetId) {
     if (!this.dataCollection || !this.dataCollection.sheets) return;
     if (Object.keys(this.dataCollection.sheets).indexOf(sheetId) < 0) return;
     var sheet = this.dataCollection.sheets[sheetId];
     var sheetReps = [];
     var i;
     for (i = 0; i < sheet.dr.length; i++) {
         var drawingId = sheet.dr[i];
         var repsByDrawing = this.GetRepsByAttribute(title, value, drawingId);
         sheetReps = sheetReps.concat(repsByDrawing);
     }
     return sheetReps;
 }
 function GetInstancesByData(dataId) {
     var _this3 = this;
     if (!this.dataCollection || !this.dataCollection.instances) return;
     var instanceIds = Object.keys(this.dataCollection.instances).filter(function (instanceId) {
         var inst = _this3.dataCollection.instances[instanceId];
         if (inst.da.indexOf(dataId) >= 0) {
             return instanceId;
         }
     });
     return instanceIds;
 }
 function LoadDrawing(drawing) {
     var mono = this;
     return new Promise(function (resolve, reject) {
         if (!mono.dataCollection || !mono.dataCollection.drawings) return;
         mono.dataCollection.drawings[drawing.monocleId] = drawing;
         return resolve(drawing);
     });
 }
 function SetHighlights() {
 	var cssStyle = {
 		"fill": "#000000",
 		"fill-opacity": 0,
 		"stroke": "#FFCB00",
 		"stroke-width": 1,
 		"stroke-opacity": 0.75,
 		"stroke-linecap": "round"
 	};
 	var styleText = '.hoverstyle{ ';
 	Object.keys(cssStyle).forEach(function (k) {
 		styleText += k + ":" + cssStyle[k] + ";";
 	});
 	styleText += "}";
 	this.styles.text(this.styles.text() + styleText);
 }
 function OnClickShowData(groupID, target, environment) {
 	var monocle = this;
 	var data = {};
 	this.SetOnClickHandler(groupID, function () {
 		data = monocle.GetGroupData(groupID);
 		if (target) target(data, environment);
 	});
 }
 var methods = /*#__PURE__*/Object.freeze({
  sampleFunction2: sampleFunction2,
  addCanvas: addCanvas,
  load: load,
  setSheet: setSheet,
  renderToSheet: renderToSheet,
  resolveDrawing: resolveDrawing,
  findObjectsByValue: findObjectsByValue,
  zoomed: zoomed,
  scale: scale,
  updateScale: updateScale,
  zoomRegion: zoomRegion,
  setScaleTracker: setScaleTracker,
  GetInstanceRepsByRep: GetInstanceRepsByRep,
  GetInstanceByRep: GetInstanceByRep,
  GetInstanceData: GetInstanceData,
  GetDataByAttribute: GetDataByAttribute,
  GetInstancesByData: GetInstancesByData,
  GetGroupData: GetGroupData,
  GetRepsByAttribute: GetRepsByAttribute,
  GetRepsOnSheetByAttribute: GetRepsOnSheetByAttribute,
  LoadDrawing: LoadDrawing,
  GetAllInstanceReps: GetAllInstanceReps,
  GetGradientMapByAttributeName: GetGradientMapByAttributeName,
  ScaleNumber: ScaleNumber,
  GetDataByKey: GetDataByKey,
  SetAttributeOnMouseOver: SetAttributeOnMouseOver,
  SetAttributeOnMouseOut: SetAttributeOnMouseOut,
  SetOnClickHandler: SetOnClickHandler,
  SetHighlights: SetHighlights,
  OnClickShowData: OnClickShowData,
  renderDrawings: renderDrawings,
  clearDrawings: clearDrawings,
  resolveUrl: resolveUrl,
  resolveDataUrl: resolveDataUrl,
  colorByAttribute: colorByAttribute,
  highLightElement: highLightElement,
  colorElement: colorElement,
  highlightElementByIds: highlightElementByIds,
  filterElement: filterElement,
  removeColorByAttribute: removeColorByAttribute,
  resetXLayer: resetXLayer,
  resetLayer: resetLayer,
  clearExistingHighlightOutlines: clearExistingHighlightOutlines,
  grayoutAll: grayoutAll,
  removeAllColorBy: removeAllColorBy,
  loadData: loadData,
  advancedGradientDict: advancedGradientDict,
  setHoverColor: setHoverColor,
  setHoverWeight: setHoverWeight,
  setHoverSensitivity: setHoverSensitivity,
  setColorByWeight: setColorByWeight,
  setColorByFill: setColorByFill,
  setColorByOpacity: setColorByOpacity,
  setLayerLockStatus: setLayerLockStatus,
  setLayerVisibilityStatus: setLayerVisibilityStatus,
  setAllLayers: setAllLayers
 });
 function sampleFunction1() {}
 var statics = /*#__PURE__*/Object.freeze({
  sampleFunction1: sampleFunction1
 });
 var Monocle = function Monocle() {
 	classCallCheck(this, Monocle);
 	this.viewer = new MonocleViewer();
 	this.dataCollection = null;
 	this.defs = null;
 	this.styles = null;
 	this.threadData = {};
 	var script = document.createElement('script');
 	script.setAttribute('type', 'text/javascript');
 	document.head.appendChild(script);
 };
 Object.keys(methods).forEach(function (methodName) {
 	Monocle.prototype[methodName] = methods[methodName];
 });
 Object.keys(statics).forEach(function (methodName) {
 	Monocle[methodName] = statics[methodName];
 });
 Monocle.version = "0.3.57";
 return Monocle;
})));
